import { ProjectTypeApiModel } from "@/core/models/api/project-type-api-model.model";
import { createActionGroup, emptyProps, props } from "@ngrx/store";

export enum ProjectTypeActionTypes {
  LoadProjectTypes = 'Load ProjectTypes',
  LoadProjectTypeSuccess = 'Load ProjectType Success',
  LoadProjectTypeFail = 'Load ProjectType Fail',
  AddProjectType = 'Add ProjectType',
  AddProjectTypeSuccess = 'Add ProjectType Success',
  UpsertProjectType = 'Upsert ProjectType',
  AddProjectTypes = 'Add ProjectTypes',
  UpsertProjectTypes = 'Upsert ProjectTypes',
  UpdateProjectType = 'Update ProjectType',
  UpdateProjectTypeSuccess = 'Update ProjectType Success',
  UpdateProjectTypes = 'Update ProjectTypes',
  DeleteProjectType = 'Delete ProjectType',
  DeleteProjectTypes = 'Delete ProjectTypes',
  ClearProjectTypes = 'Clear ProjectTypes'
}

export const ProjectTypeActions = createActionGroup({
    source: 'ProjectType',
    events: {
        [ProjectTypeActionTypes.LoadProjectTypes]: emptyProps(),
        [ProjectTypeActionTypes.LoadProjectTypeSuccess]: props<{ projectTypes: ProjectTypeApiModel[] }>(),
        [ProjectTypeActionTypes.LoadProjectTypeFail]: props<{ error: string }>(),
        [ProjectTypeActionTypes.AddProjectTypeSuccess]: props<{ projectType: ProjectTypeApiModel }>(),
        [ProjectTypeActionTypes.AddProjectType]: props<{ projectType: ProjectTypeApiModel }>(),
        [ProjectTypeActionTypes.UpdateProjectType]: props<{ projectType: ProjectTypeApiModel }>(),
        [ProjectTypeActionTypes.UpdateProjectTypeSuccess]: props<{ projectType: ProjectTypeApiModel }>(),
        [ProjectTypeActionTypes.DeleteProjectType]: props<{ projectTypeId: number }>(),
        [ProjectTypeActionTypes.ClearProjectTypes]: emptyProps()
    }
});